import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';
import { THEME } from '@/styles/theme';
import styled from 'styled-components';

export const CardNewWrapper = styled.div`
  position: relative;
  display: flex;
  padding: 20px 24px;
  border-radius: 12px;
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.grey[400]};

  ${media.mobile`
    padding: ${THEME.offset.mobile};
  `}
`;

export const CardNewContent = styled.div<{
  ratio?: number;
  width?: string;
  justifyContent?: string;
}>`
  ${flex({ flexDirection: 'column' })};
  flex: 1;
  min-width: 0;

  ${({ ratio }) =>
    ratio &&
    `
    flex: ${ratio};
  `};

  ${({ justifyContent }) =>
    justifyContent &&
    `
    justify-content: ${justifyContent};
  `};

  ${({ width }) =>
    width &&
    `
    width: ${width};
  `};

  ${media.mobile`
    ${flex({ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' })};
  `}
`;
